import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { Location } from '@angular/common';
import { AuthService } from '../../../services/auth.service'; // Adjust the import path as necessary
import { ToastService } from '../../../services/toast.service';
import { StripeService } from '../../../services/stripe.service';

@Component({
  selector: 'app-enter-otp',
  templateUrl: './enter-otp.component.html',
  styleUrls: ['./enter-otp.component.scss']
})
export class EnterOtpComponent {
  otp: string = '';
  @Input() email: string = '';
  @Input() isForgotPasswordComponent: boolean = false;
  @Input() showReset: boolean = false;

  config = {
    length: 6, // Length of the OTP
    allowNumbersOnly: true, // Allow only numbers
    inputStyles: {
      width: '40px',
      height: '40px',
      border: 'none',
      color: 'white',
      'font-family': 'Poppins',
      'border-bottom': '2px solid white',
      'background-color': 'transparent',
      outline: 'none',
      'box-shadow': 'none'
    }
  };

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private toaster: ToastService
  ) { }

  onInputChange(otp: string): void {
    this.otp = otp;
  }

  verifyOtp(): void {
    if (!this.email || !this.otp) {
      console.error('Email or OTP is missing');
      return;
    }
    this.authService.verifyOtp({ otp: this.otp, email: this.email }).subscribe({
      next: (response) => {

        const { token, user } = response;
        this.authService.setAuthData(token, user);

        if (this.isForgotPasswordComponent === false) {
          this.toaster.showToast('Email Verified', 'success');
          this.router.navigate(['/'], { replaceUrl: true });
        }
        else if (this.isForgotPasswordComponent === true) {
          this.toaster.showToast('OTP verified', 'success');
          this.showReset = true;
        }
      },
      error: (error) => {
        this.toaster.showToast('OTP incorrect', 'error');
        console.error('Error verifying OTP', error);
      }
    });
  }
}
